var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20.3333C16.5523 20.3333 17 20.781 17 21.3333V24.4713C18.2211 24.8167 19.1833 25.7789 19.5286 27H24C24.5523 27 25 27.4477 25 28C25 28.5523 24.5523 29 24 29H19.5286C19.0934 30.539 17.6784 31.6667 16 31.6667C14.3216 31.6667 12.9066 30.539 12.4714 29H8C7.44772 29 7 28.5523 7 28C7 27.4477 7.44772 27 8 27H12.4714C12.8167 25.7789 13.7789 24.8167 15 24.4713V21.3333C15 20.781 15.4477 20.3333 16 20.3333ZM16 26.3333C15.0795 26.3333 14.3333 27.0795 14.3333 28C14.3333 28.9205 15.0795 29.6667 16 29.6667C16.9205 29.6667 17.6667 28.9205 17.6667 28C17.6667 27.0795 16.9205 26.3333 16 26.3333Z",
    fill: "#3A4369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1959 8.20533C22.6003 5.60571 21.2086 3.78706 19.4137 2.73478C17.4863 1.6048 15.19 1.41451 13.1233 1.95595C11.0565 2.49739 9.1472 3.78937 8.01748 5.71889C7.03047 7.40466 6.68093 9.50513 7.2591 11.8718C1.75796 13.3211 2.18427 21.8863 8.42228 22.3308C8.44593 22.3325 8.46964 22.3333 8.49335 22.3333H21.3693C23.1818 22.3477 24.9254 21.6669 26.2653 20.4534C30.5332 16.7127 28.5365 9.46616 23.1959 8.20533ZM8.52921 13.6801C8.64714 13.6822 8.76745 13.6633 8.88503 13.621C9.40474 13.4342 9.67458 12.8614 9.48772 12.3417C8.64735 10.0043 8.92958 8.1194 9.74341 6.72941C10.5712 5.31558 12.0069 4.31589 13.6301 3.89066C15.2534 3.46542 16.9921 3.63346 18.4022 4.46014C19.7883 5.27278 20.9535 6.77795 21.3602 9.23023C21.4325 9.66606 21.7822 10.0028 22.2204 10.0586C26.3946 10.5901 28.1035 16.1901 24.9419 18.9538L24.9278 18.9664C23.9497 19.8545 22.6846 20.3445 21.3819 20.3333L8.53075 20.3333C4.37154 20.0048 4.39074 14.0079 8.52921 13.6801Z",
    fill: "#008575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudConnection);
export default __webpack_public_path__ + "static/media/cloud-connection.aeb76d1eea4a252b04865f8e05b6bf88.svg";
export { ForwardRef as ReactComponent };